(function () {
    "use strict";

    angular.module("sempraWebapp").component("reportByBox", {
        templateUrl: "app/reports/avgByBoxReport/byBoxComponent/byBox.html",
        controller: reportByBoxController,
        bindings: {
            data: "<"
        },
        controllerAs: "vm"
    });

    function reportByBoxController($translate, reportExportUtil, exportToCsv) {
        var vm = this;
        vm.report = vm.data;
        vm.exportToCsv = exportCsv;

        function exportCsv() {
            var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
                $translate.instant('BOXES'),
                vm.report.data,
                reportExportUtil.ValueFormattersEnum.DEFAULT,
                reportExportUtil.ValueFormattersEnum.NUMBER);

            exportToCsv.export(jsonArrayForExport,
                $translate.instant(vm.data.data.title),
                true);
        }


    }
})();
